import { SvgIcon, SvgIconProps } from '@mui/material';

const CancelOutlined = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="CancelOutlinedIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path d="M12.001 10.5859L15.5361 7.05078L16.9502 8.46484L13.415 12L16.9502 15.5352L15.5352 16.9502L12 13.415L8.46484 16.9502L7.05078 15.5361L10.5859 12.001L7.0498 8.46484L8.46484 7.0498L12.001 10.5859Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C17.5228 2 21.9999 6.47721 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2.00007 6.47721 6.47719 2 12 2ZM12 4C7.58176 4 4.00007 7.58178 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C19.9999 7.58178 16.4182 4 12 4Z"
      />
    </SvgIcon>
  );
};

export default CancelOutlined;
